export const filterByFirstParamValue = (param): boolean => !!param;
